﻿export interface IPendingSwapDonor {
    id: number,
    alias: string,
    center: string,
    centerId: number,
    rdnCenter: string,
    rdnCenterId: number,
    rawTypingUploadPath: string,
    ctReportUploadPath: string,
    centerAboUploadPath: string, 
    medChartUploadPath: string,
    vrlAboUploadPath: string,
    serologyRecipientId: number,
    serologyUploadDateTime: string,
    kidneyPickupDateTime: string,
    pairStatusValue: number,
    pairStatus: string,
    histogeneticsPdfAboFile: string,
    histogeneticsPdfTypingFile: string
}
